export default {"src":"/_next/static/media/cardAndLetter_40.48ab82d7.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};